import { Badge } from "@/components/ui/badge";
import {
  AlutecLogo,
  BbsLogo,
  ContinentalLogo,
  EnkeiLogo,
  HankookLogo,
  OzLogo,
  PirelliLogo,
} from "@/components/icons/assets";

export default function BrandsSection() {
  return (
    <section className="px-4 md:px-8 lg:px-20 pt-30 pb-30 bg-background-50">
      <div className="text-center mb-12">
        <Badge
          variant="outline"
          className="font-plus-jakarta font-semibold px-6 py-2 bg-background-50 border-stroke text-neutral-500 rounded-full text-base mb-5"
        >
          Wheel Brands
        </Badge>
        <h2 className="font-plus-jakarta text-4xl md:text-6xl font-bold text-neutral-900 leading-tight mb-5 max-w-xl mx-auto">
          WHEELS FROM TRUSTED BRANDS
        </h2>
        <p className="font-plus-jakarta text-sm text-neutral-300 max-w-2xl mx-auto">
          Explore our collection of wheels from the most trusted and renowned
          brands in the automotive industry. Choose from premium wheels for
          performance, style, and reliability.
        </p>
      </div>

      <div className="flex flex-wrap justify-center items-center gap-4">
        <BbsLogo />
        <OzLogo />
        <ContinentalLogo />
        <PirelliLogo />
        <HankookLogo />
        <AlutecLogo />
        <EnkeiLogo />
      </div>
    </section>
  );
}
